// extracted by mini-css-extract-plugin
export default {"zr-main-container":"App_zr-main-container__oU5b4","zr-main-content":"App_zr-main-content__vcLot","zr-fullscreen":"App_zr-fullscreen__ud5JU"};